(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["havstein-boards-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const thumb=event.target.closest('.hu-gallery__thumb');if(!thumb)return;const gallery=thumb.closest('.hu-gallery');if(!gallery)return;const image=gallery.querySelector('.hu-gallery__main');const link=gallery.querySelector('.hu-gallery__zoom');const buttons=[...gallery.querySelectorAll('.hu-gallery__thumb')];const full=thumb.dataset.full;image.src=full+'&width=1100';image.alt=thumb.dataset.alt;link.href=full;buttons.forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));gallery.querySelector('.hu-gallery__count').textContent=(buttons.indexOf(thumb)+1)+' / '+buttons.length});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["havstein-utensils-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const thumb=event.target.closest('.hu-gallery__thumb');if(!thumb)return;const gallery=thumb.closest('.hu-gallery');if(!gallery)return;const image=gallery.querySelector('.hu-gallery__main');const link=gallery.querySelector('.hu-gallery__zoom');const buttons=[...gallery.querySelectorAll('.hu-gallery__thumb')];const full=thumb.dataset.full;image.src=full+'&width=1100';image.alt=thumb.dataset.alt;link.href=full;buttons.forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));gallery.querySelector('.hu-gallery__count').textContent=(buttons.indexOf(thumb)+1)+' / '+buttons.length});
  } catch(e) { console.error(e); }
})();

})();
